// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.follow-up-questions {
  position: relative;
  width: 100%;
  display: grid !important;
  grid-template-columns: repeat(auto-fit, minmax(24%, -webkit-max-content));
  grid-template-columns: repeat(auto-fit, minmax(24%, max-content));
  grid-gap: 5px;
  gap: 5px;
  margin-top: 10px;
  overflow-y: auto;
}
@media screen and (max-width: 1023px) {
  .follow-up-questions {
    grid-template-columns: repeat(auto-fit, minmax(33%, -webkit-max-content));
    grid-template-columns: repeat(auto-fit, minmax(33%, max-content));
  }
}
@media screen and (max-width: 1123px) {
  .follow-up-questions {
    grid-template-columns: repeat(auto-fit, minmax(33%, -webkit-max-content));
    grid-template-columns: repeat(auto-fit, minmax(33%, max-content));
  }
}
@media screen and (max-width: 767px) {
  .follow-up-questions {
    grid-template-columns: repeat(auto-fit, minmax(100%, -webkit-max-content));
    grid-template-columns: repeat(auto-fit, minmax(100%, max-content));
  }
}
.follow-up-questions::before {
  display: none !important;
}
.follow-up-questions::after {
  display: none !important;
}
.follow-up-questions__title {
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--primary-color-500);
  margin: 0 0 0.5rem 0;
  padding-left: 0.5rem;
}
.follow-up-questions__list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-flow: column;
  gap: 0.15rem;
}
.follow-up-questions__item {
  width: 100%;
}
.follow-up-questions__item::before {
  display: none !important;
}
.follow-up-questions__button {
  width: 100%;
  padding: 0.25rem;
  background-color: var(--primary-color-light-200);
  border: 1px solid var(--primary-color-light-200);
  border-radius: 0.5rem;
  cursor: pointer;
  text-align: left;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  color: var(--primary-color-500);
}
.follow-up-questions__button:hover {
  background-color: var(--primary-color-light-500);
  border-color: var(--secondary-color-500);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  color: var(--secondary-color-500);
}
.follow-up-questions__button:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}
.follow-up-questions__text {
  font-size: 0.875rem;
  line-height: 1.4;
  font-weight: 500;
  display: block;
}
.follow-up-questions__category {
  font-size: 0.75rem;
  color: var(--primary-color-500);
  font-weight: 400;
  background-color: var(--primary-color-light-200);
  padding: 0.5rem 0.5rem;
  border-radius: 0.25rem;
  display: inline-block;
  width: -webkit-fit-content;
  width: fit-content;
  border-radius: 15px;
}
.follow-up-questions__error {
  grid-column: 1/-1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem 1rem;
  background-color: #f8f9fa;
  background-color: var(--color-background-light, #f8f9fa);
  border: 1px solid #e9ecef;
  border: 1px solid var(--color-border-light, #e9ecef);
  border-radius: 0.5rem;
  margin: 1rem 0;
}
.follow-up-questions__error-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 1rem;
  max-width: 300px;
}
.follow-up-questions__error-icon {
  font-size: 2.5rem;
  color: #ffc107;
  color: var(--color-warning, #ffc107);
}
.follow-up-questions__error-message {
  font-size: 0.875rem;
  color: #6c757d;
  color: var(--color-text-secondary, #6c757d);
  margin: 0;
  line-height: 1.4;
}
.follow-up-questions__refresh-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  background-color: #007bff;
  background-color: var(--primary-color-500, #007bff);
  color: white;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.2s ease;
}
.follow-up-questions__refresh-button:hover {
  background-color: #0056b3;
  background-color: var(--primary-color-700, #0056b3);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.3);
}
.follow-up-questions__refresh-button:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);
}
.follow-up-questions__refresh-button:active {
  transform: translateY(0);
  box-shadow: 0 1px 4px rgba(0, 123, 255, 0.3);
}
.follow-up-questions__refresh-button .material-icons {
  font-size: 1.125rem;
}
.follow-up-questions__no-results {
  grid-column: 1/-1;
  text-align: center;
  color: #6c757d;
  color: var(--color-text-secondary, #6c757d);
  font-style: italic;
  padding: 2rem 1rem;
  margin: 0;
}
@media screen and (min-width: 768px) {
  .follow-up-questions__title {
    font-size: 1rem;
  }
  .follow-up-questions__button {
    padding: 0.25rem 0.5rem;
  }
  .follow-up-questions__text {
    font-size: 0.75rem;
  }
  .follow-up-questions__category {
    font-size: 0.875rem;
  }
}
.follow-up-questions--compact .follow-up-questions__button {
  padding: 0.75rem;
}
.follow-up-questions--compact .follow-up-questions__text {
  font-size: 0.8rem;
}
.follow-up-questions--compact .follow-up-questions__category {
  font-size: 0.7rem;
  padding: 0.2rem 0.4rem;
}
.follow-up-questions--grid-2 .follow-up-questions__list {
  grid-template-columns: repeat(2, 1fr);
}
.follow-up-questions--grid-3 .follow-up-questions__list {
  grid-template-columns: repeat(3, 1fr);
}
@media screen and (max-width: 767px) {
  .follow-up-questions--grid-2 .follow-up-questions__list, .follow-up-questions--grid-3 .follow-up-questions__list {
    grid-template-columns: 1fr;
  }
}

.follow-up-questions-wrapper {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/layouts/user/Research/components/FollowUpQuestions/FollowUpQuestions.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,wBAAA;EACA,yEAAA;EAAA,iEAAA;EACA,aAAA;EAAA,QAAA;EACA,gBAAA;EACA,gBAAA;AACF;AACE;EATF;IAUI,yEAAA;IAAA,iEAAA;EAEF;AACF;AAAE;EAbF;IAcI,yEAAA;IAAA,iEAAA;EAGF;AACF;AADE;EAjBF;IAkBI,0EAAA;IAAA,kEAAA;EAIF;AACF;AAFE;EACE,wBAAA;AAIJ;AADE;EACE,wBAAA;AAGJ;AAAE;EACE,mBAAA;EACA,gBAAA;EACA,+BAAA;EACA,oBAAA;EACA,oBAAA;AAEJ;AACE;EACE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,iBAAA;EACA,YAAA;AACJ;AAEE;EACE,WAAA;AAAJ;AACI;EACE,wBAAA;AACN;AAGE;EACE,WAAA;EACA,gBAAA;EACA,gDAAA;EACA,gDAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,+BAAA;AADJ;AAGI;EACE,gDAAA;EACA,wCAAA;EACA,yCAAA;EACA,iCAAA;AADN;AAII;EACE,aAAA;EACA,kCAAA;EACA,6CAAA;AAFN;AAME;EACE,mBAAA;EACA,gBAAA;EAEA,gBAAA;EACA,cAAA;AALJ;AAQE;EACE,kBAAA;EACA,+BAAA;EACA,gBAAA;EACA,gDAAA;EACA,sBAAA;EACA,sBAAA;EACA,qBAAA;EACA,0BAAA;EAAA,kBAAA;EACA,mBAAA;AANJ;AASE;EACE,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EAAA,wDAAA;EACA,yBAAA;EAAA,oDAAA;EACA,qBAAA;EACA,cAAA;AAPJ;AAUE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;AARJ;AAWE;EACE,iBAAA;EACA,cAAA;EAAA,oCAAA;AATJ;AAYE;EACE,mBAAA;EACA,cAAA;EAAA,2CAAA;EACA,SAAA;EACA,gBAAA;AAVJ;AAaE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,yBAAA;EAAA,mDAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;AAXJ;AAaI;EACE,yBAAA;EAAA,mDAAA;EACA,2BAAA;EACA,4CAAA;AAXN;AAcI;EACE,aAAA;EACA,6CAAA;AAZN;AAeI;EACE,wBAAA;EACA,4CAAA;AAbN;AAgBI;EACE,mBAAA;AAdN;AAkBE;EACE,iBAAA;EACA,kBAAA;EACA,cAAA;EAAA,2CAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;AAhBJ;AAoBE;EACE;IACE,eAAA;EAlBJ;EAqBE;IACE,uBAAA;EAnBJ;EAsBE;IACE,kBAAA;EApBJ;EAuBE;IACE,mBAAA;EArBJ;AACF;AA0BI;EACE,gBAAA;AAxBN;AA2BI;EACE,iBAAA;AAzBN;AA4BI;EACE,iBAAA;EACA,sBAAA;AA1BN;AAgCI;EACE,qCAAA;AA9BN;AAmCI;EACE,qCAAA;AAjCN;AAqCE;EAGI;IACE,0BAAA;EArCN;AACF;;AA0CA;EACE,WAAA;AAvCF","sourcesContent":[".follow-up-questions {\n  position: relative;\n  width: 100%;\n  display: grid !important;\n  grid-template-columns: repeat(auto-fit, minmax(24%, max-content));\n  gap: 5px;\n  margin-top: 10px;\n  overflow-y: auto;\n\n  @media screen and (max-width: 1023px) {\n    grid-template-columns: repeat(auto-fit, minmax(33%, max-content));\n  }\n\n  @media screen and (max-width: 1123px) {\n    grid-template-columns: repeat(auto-fit, minmax(33%, max-content));\n  }\n\n  @media screen and (max-width: 767px) {\n    grid-template-columns: repeat(auto-fit, minmax(100%, max-content));\n  }\n\n  &::before {\n    display: none !important;\n  }\n\n  &::after {\n    display: none !important;\n  }\n\n  &__title {\n    font-size: 1.125rem;\n    font-weight: 600;\n    color: var(--primary-color-500);\n    margin: 0 0 0.5rem 0;\n    padding-left: 0.5rem;\n  }\n\n  &__list {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    display: flex;\n    flex-flow: column;\n    gap: 0.15rem;\n  }\n\n  &__item {\n    width: 100%;\n    &::before {\n      display: none !important;\n    }\n  }\n\n  &__button {\n    width: 100%;\n    padding: 0.25rem;\n    background-color: var(--primary-color-light-200);\n    border: 1px solid var(--primary-color-light-200);\n    border-radius: 0.5rem;\n    cursor: pointer;\n    text-align: left;\n    transition: all 0.2s ease;\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    color: var(--primary-color-500);\n    \n    &:hover {\n      background-color: var(--primary-color-light-500);\n      border-color: var(--secondary-color-500);\n      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n      color: var(--secondary-color-500);\n    }\n\n    &:focus {\n      outline: none;\n      border-color: var(--color-primary);\n      box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\n    }\n  }\n\n  &__text {\n    font-size: 0.875rem;\n    line-height: 1.4;\n    // color: var(--primary-color-500);\n    font-weight: 500;\n    display: block;\n  }\n\n  &__category {\n    font-size: 0.75rem;\n    color: var(--primary-color-500);\n    font-weight: 400;\n    background-color: var(--primary-color-light-200);\n    padding: 0.5rem 0.5rem;\n    border-radius: 0.25rem;\n    display: inline-block;\n    width: fit-content;\n    border-radius: 15px;\n  }\n\n  &__error {\n    grid-column: 1 / -1;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 2rem 1rem;\n    background-color: var(--color-background-light, #f8f9fa);\n    border: 1px solid var(--color-border-light, #e9ecef);\n    border-radius: 0.5rem;\n    margin: 1rem 0;\n  }\n\n  &__error-content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    gap: 1rem;\n    max-width: 300px;\n  }\n\n  &__error-icon {\n    font-size: 2.5rem;\n    color: var(--color-warning, #ffc107);\n  }\n\n  &__error-message {\n    font-size: 0.875rem;\n    color: var(--color-text-secondary, #6c757d);\n    margin: 0;\n    line-height: 1.4;\n  }\n\n  &__refresh-button {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.75rem 1.5rem;\n    background-color: var(--primary-color-500, #007bff);\n    color: white;\n    border: none;\n    border-radius: 0.5rem;\n    cursor: pointer;\n    font-size: 0.875rem;\n    font-weight: 500;\n    transition: all 0.2s ease;\n\n    &:hover {\n      background-color: var(--primary-color-700, #0056b3);\n      transform: translateY(-1px);\n      box-shadow: 0 2px 8px rgba(0, 123, 255, 0.3);\n    }\n\n    &:focus {\n      outline: none;\n      box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);\n    }\n\n    &:active {\n      transform: translateY(0);\n      box-shadow: 0 1px 4px rgba(0, 123, 255, 0.3);\n    }\n\n    .material-icons {\n      font-size: 1.125rem;\n    }\n  }\n\n  &__no-results {\n    grid-column: 1 / -1;\n    text-align: center;\n    color: var(--color-text-secondary, #6c757d);\n    font-style: italic;\n    padding: 2rem 1rem;\n    margin: 0;\n  }\n\n  // Responsive adjustments\n  @media screen and (min-width: 768px) {\n    &__title {\n      font-size: 1rem;\n    }\n\n    &__button {\n      padding: 0.25rem 0.5rem;\n    }\n\n    &__text {\n      font-size: 0.75rem;\n    }\n\n    &__category {\n      font-size: 0.875rem;\n    }\n  }\n\n  // Compact variant for smaller spaces\n  &--compact {\n    .follow-up-questions__button {\n      padding: 0.75rem;\n    }\n\n    .follow-up-questions__text {\n      font-size: 0.8rem;\n    }\n\n    .follow-up-questions__category {\n      font-size: 0.7rem;\n      padding: 0.2rem 0.4rem;\n    }\n  }\n\n  // Grid layout variants\n  &--grid-2 {\n    .follow-up-questions__list {\n      grid-template-columns: repeat(2, 1fr);\n    }\n  }\n\n  &--grid-3 {\n    .follow-up-questions__list {\n      grid-template-columns: repeat(3, 1fr);\n    }\n  }\n\n  @media screen and (max-width: 767px) {\n    &--grid-2,\n    &--grid-3 {\n      .follow-up-questions__list {\n        grid-template-columns: 1fr;\n      }\n    }\n  }\n}\n\n.follow-up-questions-wrapper {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
